<template>
  <div id="login" class="flex column wrap justify-center grow-1">
    <form class="form flex column grow-1 align-start align-self-center justify-center justify-flex-start-sm">
      <h1>Iniciar sesión: Control Empresarial</h1>
      <div class="form-group">
        <input
          @keypress.enter="submitLogin"
          type="email"
          id="email"
          name="email"
          placeholder="Correo"
          class="text-input"
          v-model="email"
          autofocus
          required
        />
        <span v-if="this.errors.email.length" class="error">{{ this.errors.email[0] }}</span>
      </div>
      <div class="form-group">
        <input
          @keypress.enter="submitLogin"
          type="password"
          id="password"
          name="password"
          placeholder="Contraseña"
          class="text-input"
          v-model="password"
          required
        />
      </div>
      <div v-if="this.showRFC" class="form-group">
        <input
          @keypress.enter="submitLogin"
          type="text"
          id="rfc"
          name="rfc"
          placeholder="RFC"
          class="text-input"
          v-model="rfc"
        />
        <span v-if="this.errors.rfc.length" class="error">{{ this.errors.rfc[0] }}</span>
      </div>
      <div class="flex justify-space-evenly dspl-inline-grid-m dspl-inline-grid-sm justify-stretch-sm login-buttons">
        <button class="btn" @click.prevent="submitLogin">Ingresar</button>
        <button class="btn" @click.prevent="routeToNormal">Acceso a Línea Exprés</button>
      </div>
    </form>
      <nav class="flex justify-space-between align-self-center nav">
        <router-link to="/reset-password-request" class="color-text">
          ¿Olvidaste tu contraseña?
        </router-link>
        <router-link to="/terms-and-conditions" class="color-text">
          Términos y Condiciones
        </router-link>
      </nav>
      <ErrorModal
        @confirm="confirmModalError"
        :active="showModalError"
        message="Revisa que tus credenciales de acceso sean correctas, si es tu primera vez iniciando sesión intenta nuevamente con tu RFC"
      />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ErrorModal from '@/components/ErrorModal'

export default {
  name: 'CELogin',
  data () {
    return {
      email: '',
      rfc: '',
      password: '',
      showModalError: false,
      showRFC: false,
      errors: {
        email: [],
        rfc: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'terms_accepted'
    ])
  },
  watch: {
    token: function (token) {
      if (token) {
        this.$nextTick(() => {
          this.proceedToNextRoute()
        })
      }
    }
  },
  components: {
    ErrorModal
  },
  methods: {
    ...mapActions('user', [
      'login'
    ]),
    routeToNormal () {
      this.$router.push('/')
    },
    cleanErrors () {
      this.errors = {
        email: [],
        rfc: []
      }
    },
    confirmModalError () {
      if (this.showRFC === false) {
        this.showRFC = true
      }
      this.showModalError = false
    },
    submitLogin: function () {
      const emailRegexp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/

      this.cleanErrors()

      if (!emailRegexp.test(this.email)) {
        this.errors = { ...this.errors, email: ['El email debe tener un formato válido'] }
      }

      if (!this.errors.email.length && !this.errors.rfc.length) {
        this.sendData()
      }
    },
    sendData: function () {
      const data = { email: this.email, rfc: this.rfc, password: this.password }
      this.login(data).then(() => {}).catch((_) => {
        this.showModalError = true
      })
    },
    proceedToNextRoute: function () {
      if (this.terms_accepted) {
        this.$router.push('/vehicles')
      } else {
        this.$router.push('/terms-and-conditions')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#login {
  height: 100vh;
}

.form {
  width: 50%;
}

.text-input {
  font-size: 1rem;
  padding: 0.8rem;
  border-radius: 20px;
  border-width: 0;
  width: 100%;

  &:focus {
    outline-width: 0;
  }
}

.error {
  font-size: 0.75rem;
  color: $red;
  margin: 0 0.5rem;
}

.form-group {
  width: 100%;
  margin: 0.75rem 0;
  text-align: left;
}

.btn {
  font-size: 0.8rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6rem 1.5rem;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
}

.color-text{
  color: $blue;
  text-decoration:none;
}

.login-buttons {
  width: 100%;
}

.sentri-input {
  width: 100%;
  position: relative;

  .btn {
    position: absolute;
    top: 0;
    right: -1rem;
    margin: 20px 0px;
  }
}

.nav {
  margin-bottom: 1rem;
  width: 90%;
}

@media screen and (max-width: 960px) {
  .form{
    width: 80%;
  }
}

@media screen and (max-width: 480px) {
  #login {
    height: 75vh;
    min-height: 567px;
  }

  .form{
    width: 70%;
    margin: 5% 0 5% 0;
  }

  .nav {
    bottom: 5%;
  }
}
</style>
